var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Loader_animation",
    imageRendering: "auto",
    baseProfile: "basic",
    x: "0px",
    y: "0px",
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 27.35,
    y1: -2.599,
    x2: 146.45,
    y2: 17.9,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA2427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78.823%",
    stopColor: "#F4898B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scene-1",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11 0 0 1.11 -8.2 -8.35)",
    id: "Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M140.5 76.05Q140.5 48.75 121.2 29.4 101.85 10.1 74.55 10.1 47.25 10.1 27.9 29.4 8.55 48.75 8.55 76.05 8.55 103.35 27.9 122.7 47.25 142.05 74.55 142.05 101.85 142.05 121.2 122.7 140.5 103.35 140.5 76.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-11",
    transform: "matrix(.126 0 0 .126 28.8 76.3)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.229;.247;.265;.269;.283;.3;.327;1",
    values: "29.605,82.603;29.605,82.603;33.209,82.457;35.142,82.257;35.142,82.257;34.2,82.2;34.556,82.337;34.2,82.2;34.2,82.2"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.229;.247;.265;.269;.283;.3;.327;1",
    values: ".126,.126;.126,.126;.779,.779;1.165,1.165;1.165,1.165;1,1;1.057,1.057;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.229;.247;.265;.269;.283;.3;.327;1",
    values: "-6.8,-50.5;-6.8,-50.5;-6.3,-49.55;-5.4,-49.1;-5.4,-49.1;-5.3,-49;-5.4,-49.15;-5.3,-49;-5.3,-49"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.229;.247;.265;1",
    values: "0;0;.88;1;1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -12 -58)",
    id: "Layer208_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M119.05 146.6Q103.7 143.6 89.5 145.55 55.1 150.15 38.05 177.2 31.35 187.85 30.2 200.4 30.2 200.7 30 201.3L30 208.4Q30.25 209.85 30.7 212.65 31.1 215.15 31.55 216.85 36.2 234.6 53 246.2 53.8 246.75 54 247.35 54.2 247.9 54 248.75 52.55 256 47.55 261.05L40.75 267.75 40.95 268.05Q43.6 268 48.8 267.95 53.5 267.9 56.65 267.5 66.95 266.25 75.7 257.9 76.75 256.95 78.1 257.3 107.6 263.95 132.9 254.05 155.4 245.25 165.1 224.65 171.9 210.25 169.35 194.05 166.8 177.85 155.95 166.2 141.8 151.15 119.05 146.6M56.3 188.1Q58.45 188 61.65 188.05L143.85 188.1Q145.45 188.1 146.55 189.25 147.6 190.35 147.65 191.9 147.75 193.4 146.55 194.55 145.4 195.7 143.85 195.7L143.7 195.7Q141.55 195.8 138.4 195.75L56.15 195.7Q54.55 195.7 53.45 194.55 52.4 193.45 52.35 191.9 52.3 190.4 53.45 189.25 54.65 188.1 56.15 188.1L56.3 188.1M146.55 216.1Q145.4 217.25 143.85 217.25L56.15 217.25Q54.55 217.25 53.45 216.1 52.4 215 52.35 213.4 52.3 211.9 53.45 210.75 54.65 209.6 56.15 209.6L143.85 209.6Q145.45 209.6 146.55 210.75 147.6 211.85 147.65 213.4 147.75 214.95 146.55 216.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M143.85 217.25Q145.4 217.25 146.55 216.1 147.75 214.95 147.65 213.4 147.6 211.85 146.55 210.75 145.45 209.6 143.85 209.6L56.15 209.6Q54.65 209.6 53.45 210.75 52.3 211.9 52.35 213.4 52.4 215 53.45 216.1 54.55 217.25 56.15 217.25L143.85 217.25M61.65 188.05Q58.45 188 56.3 188.1L56.15 188.1Q54.65 188.1 53.45 189.25 52.3 190.4 52.35 191.9 52.4 193.45 53.45 194.55 54.55 195.7 56.15 195.7L138.4 195.75Q141.55 195.8 143.7 195.7L143.85 195.7Q145.4 195.7 146.55 194.55 147.75 193.4 147.65 191.9 147.6 190.35 146.55 189.25 145.45 188.1 143.85 188.1L61.65 188.05Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.229;.408;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-10",
    transform: "matrix(.013 0 0 .013 122.1 107.25)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.265;.283;.3;.30499;.318;.345;.386;1",
    values: "122.6,107.7;122.6,107.7;98.176,86.448;81.806,71.968;81.806,71.968;87.968,77.304;85.387,75.16;87.95,77.35;87.95,77.35"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.265;.283;.3;.30499;.318;.345;.386;1",
    values: ".013,.013;.013,.013;.714,.714;1.179,1.179;1.179,1.179;1.003,1.003;1.076,1.076;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.265;.283;.3;.30499;.318;.345;.386;1",
    values: "-42.25,-38.45;-42.25,-38.45;-38.55,-34.8;-38,-33.6;-38,-33.6;-38,-33.55;-37.95,-33.65;-37.85,-33.5;-37.85,-33.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.265;.283;.3;1",
    values: "0;0;.88;1;1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.396 0 0 .396 -31.95 -67.15)",
    id: "Layer207_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M147.6 171.95Q117.6 177.9 99.15 197.65 84.9 212.9 81.55 234.2 78.2 255.5 87.1 274.4 99.85 301.45 129.4 313 162.65 326.05 201.35 317.25 203.2 316.85 204.55 318.05 215.9 328.95 229.6 330.7 233.75 331.2 239.85 331.3 243.3 331.35 250.15 331.45L250.4 331Q243 323.75 241.5 322.2 235.1 315.7 233.05 306.1 232.8 304.95 233.05 304.2 233.35 303.45 234.35 302.7 256.4 287.55 262.55 264.15 263.1 262 263.65 258.65 264.5 253.55 264.6 253.1L264.6 243.75Q264.3 242.95 264.25 242.55 262.8 226.05 254 212.1 231.65 176.6 186.35 170.5 167.65 167.95 147.6 171.95M122.25 226.35Q124.6 226.35 129.25 226.4L230.2 226.4Q232.25 226.4 233.7 227.9 235.15 229.35 235.2 231.4 235.3 233.4 233.75 234.9 232.2 236.4 230.2 236.4L115 236.4Q112.95 236.4 111.5 234.9 110.1 233.45 110 231.4 109.95 229.4 111.5 227.9 113 226.4 115 226.4L115.2 226.4Q118 226.3 122.25 226.35M111.5 256.15Q113 254.65 115 254.65L230.2 254.65Q232.25 254.65 233.7 256.15 235.15 257.6 235.2 259.65 235.3 261.65 233.75 263.15 232.2 264.65 230.2 264.65L230 264.65Q227.2 264.75 223 264.7L115 264.65Q112.95 264.65 111.5 263.15 110.1 261.7 110 259.65 109.95 257.65 111.5 256.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M115 254.65Q113 254.65 111.5 256.15 109.95 257.65 110 259.65 110.1 261.7 111.5 263.15 112.95 264.65 115 264.65L223 264.7Q227.2 264.75 230 264.65L230.2 264.65Q232.2 264.65 233.75 263.15 235.3 261.65 235.2 259.65 235.15 257.6 233.7 256.15 232.25 254.65 230.2 254.65L115 254.65M129.25 226.4Q124.6 226.35 122.25 226.35 118 226.3 115.2 226.4L115 226.4Q113 226.4 111.5 227.9 109.95 229.4 110 231.4 110.1 233.45 111.5 234.9 112.95 236.4 115 236.4L230.2 236.4Q232.2 236.4 233.75 234.9 235.3 233.4 235.2 231.4 235.15 229.35 233.7 227.9 232.25 226.4 230.2 226.4L129.25 226.4Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.265;.408;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-9",
    transform: "translate(28.9 33.2)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.408;.413;.417;.422;.426;.43;.435;.439;.444;.453;1",
    values: "76.35,72.75;76.35,72.75;73.703,72.751;61.858,73.086;36.375,88.705;26.855,114.788;31.677,133.084;38.574,143.712;45.971,150.101;51.045,154.401;57.093,156.359;57.093,156.359"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.408;.413;.417;.422;.426;.43;.435;.439;.444;.453;1",
    values: "0,0,0;0,0,0;-4.077,0,0;-20.043,0,0;-59.752,0,0;-97.372,0,0;-122.705,0,0;-139.043,0,0;-152.538,0,0;-159.578,0,0;-173.033,0,0;-173.033,0,0"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.413;.417;.422;.426;.43;.439;.444;1",
    values: "1,1;1,1;1,.999;.998,.998;1,1;.998,.998;.998,.998;1,.999;1,.999"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.408;.413;.417;.422;.426;.43;.435;.439;.444;.453;1",
    values: "-47.45,-39.55;-47.45,-39.55;-47.65,-39.7;-47.55,-39.7;-47.3,-39.75;-47.4,-39.6;-47.25,-39.65;-47.3,-39.6;-47.15,-39.55;-47.3,-39.5;-47.2,-39.55;-47.2,-39.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.408;.413;.417;.422;.426;.43;.435;.439;.444;.453;1",
    values: "1;1;.8;.7;.6;.4;.4;.3;.2;.1;0;0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -12 -58)",
    id: "Layer205_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M119.05 146.6Q103.7 143.6 89.5 145.55 55.1 150.15 38.05 177.2 31.35 187.85 30.2 200.4 30.2 200.7 30 201.3L30 208.4Q30.25 209.85 30.7 212.65 31.1 215.15 31.55 216.85 36.2 234.6 53 246.2 53.8 246.75 54 247.35 54.2 247.9 54 248.75 52.55 256 47.55 261.05L40.75 267.75 40.95 268.05Q43.6 268 48.8 267.95 53.5 267.9 56.65 267.5 66.95 266.25 75.7 257.9 76.75 256.95 78.1 257.3 107.6 263.95 132.9 254.05 155.4 245.25 165.1 224.65 171.9 210.25 169.35 194.05 166.8 177.85 155.95 166.2 141.8 151.15 119.05 146.6M56.3 188.1Q58.45 188 61.65 188.05L143.85 188.1Q145.45 188.1 146.55 189.25 147.6 190.35 147.65 191.9 147.75 193.4 146.55 194.55 145.4 195.7 143.85 195.7L143.7 195.7Q141.55 195.8 138.4 195.75L56.15 195.7Q54.55 195.7 53.45 194.55 52.4 193.45 52.35 191.9 52.3 190.4 53.45 189.25 54.65 188.1 56.15 188.1L56.3 188.1M146.55 216.1Q145.4 217.25 143.85 217.25L56.15 217.25Q54.55 217.25 53.45 216.1 52.4 215 52.35 213.4 52.3 211.9 53.45 210.75 54.65 209.6 56.15 209.6L143.85 209.6Q145.45 209.6 146.55 210.75 147.6 211.85 147.65 213.4 147.75 214.95 146.55 216.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M143.85 217.25Q145.4 217.25 146.55 216.1 147.75 214.95 147.65 213.4 147.6 211.85 146.55 210.75 145.45 209.6 143.85 209.6L56.15 209.6Q54.65 209.6 53.45 210.75 52.3 211.9 52.35 213.4 52.4 215 53.45 216.1 54.55 217.25 56.15 217.25L143.85 217.25M61.65 188.05Q58.45 188 56.3 188.1L56.15 188.1Q54.65 188.1 53.45 189.25 52.3 190.4 52.35 191.9 52.4 193.45 53.45 194.55 54.55 195.7 56.15 195.7L138.4 195.75Q141.55 195.8 143.7 195.7L143.85 195.7Q145.4 195.7 146.55 194.55 147.75 193.4 147.65 191.9 147.6 190.35 146.55 189.25 145.45 188.1 143.85 188.1L61.65 188.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.396 0 0 .396 -10.75 -56.5)",
    id: "Layer206_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M147.6 171.95Q117.6 177.9 99.15 197.65 84.9 212.9 81.55 234.2 78.2 255.5 87.1 274.4 99.85 301.45 129.4 313 162.65 326.05 201.35 317.25 203.2 316.85 204.55 318.05 215.9 328.95 229.6 330.7 233.75 331.2 239.85 331.3 243.3 331.35 250.15 331.45L250.4 331Q243 323.75 241.5 322.2 235.1 315.7 233.05 306.1 232.8 304.95 233.05 304.2 233.35 303.45 234.35 302.7 256.4 287.55 262.55 264.15 263.1 262 263.65 258.65 264.5 253.55 264.6 253.1L264.6 243.75Q264.3 242.95 264.25 242.55 262.8 226.05 254 212.1 231.65 176.6 186.35 170.5 167.65 167.95 147.6 171.95M122.25 226.35Q124.6 226.35 129.25 226.4L230.2 226.4Q232.25 226.4 233.7 227.9 235.15 229.35 235.2 231.4 235.3 233.4 233.75 234.9 232.2 236.4 230.2 236.4L115 236.4Q112.95 236.4 111.5 234.9 110.1 233.45 110 231.4 109.95 229.4 111.5 227.9 113 226.4 115 226.4L115.2 226.4Q118 226.3 122.25 226.35M111.5 256.15Q113 254.65 115 254.65L230.2 254.65Q232.25 254.65 233.7 256.15 235.15 257.6 235.2 259.65 235.3 261.65 233.75 263.15 232.2 264.65 230.2 264.65L230 264.65Q227.2 264.75 223 264.7L115 264.65Q112.95 264.65 111.5 263.15 110.1 261.7 110 259.65 109.95 257.65 111.5 256.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M115 254.65Q113 254.65 111.5 256.15 109.95 257.65 110 259.65 110.1 261.7 111.5 263.15 112.95 264.65 115 264.65L223 264.7Q227.2 264.75 230 264.65L230.2 264.65Q232.2 264.65 233.75 263.15 235.3 261.65 235.2 259.65 235.15 257.6 233.7 256.15 232.25 254.65 230.2 254.65L115 254.65M129.25 226.4Q124.6 226.35 122.25 226.35 118 226.3 115.2 226.4L115 226.4Q113 226.4 111.5 227.9 109.95 229.4 110 231.4 110.1 233.45 111.5 234.9 112.95 236.4 115 236.4L230.2 236.4Q232.2 236.4 233.75 234.9 235.3 233.4 235.2 231.4 235.15 229.35 233.7 227.9 232.25 226.4 230.2 226.4L129.25 226.4Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.408;.457;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f98o56",
    transform: "matrix(-.929 -.37 .37 -.929 71.5 207.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer204_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 49.6L41.4 52.05",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer203_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 58.45L27.4 43.2",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer202_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 58.3L34.3 43.35",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.251;.256;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f97o55",
    transform: "matrix(-.845 -.535 .535 -.845 56.35 205.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer201_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 52.75L41.4 48.9",
    strokeOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer200_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 59.15L27.4 42.5",
    strokeOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer199_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 57.5L34.3 44.15",
    strokeOpacity: 0.14
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.14
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.247;.251;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f96o54",
    transform: "matrix(-.732 -.681 .681 -.732 41.7 201.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer198_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 53.45L41.4 48.2",
    strokeOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer197_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 41.8L27.4 59.85",
    strokeOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer196_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 56.75L34.3 44.9",
    strokeOpacity: 0.27
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.27
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.242;.247;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f95o53",
    transform: "matrix(-.652 -.758 .758 -.652 33.45 196.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer195_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 54.2L41.4 47.45",
    strokeOpacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer194_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 41.8L27.4 59.85",
    strokeOpacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer193_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 55.95L34.3 45.7",
    strokeOpacity: 0.41
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.41
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.238;.242;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f94o52",
    transform: "matrix(-.563 -.826 .826 -.563 25.6 191.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer192_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 54.9L41.4 46.75",
    strokeOpacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer191_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 59.05L27.4 42.6",
    strokeOpacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer190_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 55.15L34.3 46.5",
    strokeOpacity: 0.54
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.54
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.233;.238;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f93o51",
    transform: "matrix(-.363 -.932 .932 -.363 11.2 178.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer189_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 55.6L41.4 46.05",
    strokeOpacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer188_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 58.3L27.4 43.35",
    strokeOpacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer187_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 54.4L34.3 47.25",
    strokeOpacity: 0.67
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.67
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.229;.233;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f92o50",
    transform: "matrix(-.144 -.99 .99 -.144 -.5 163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer186_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 56.3L41.4 45.35",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer185_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 57.5L27.4 44.15",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer184_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 53.6L34.3 48.05",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.224;.229;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f91o49",
    transform: "matrix(.247 -.969 .969 .247 -11.2 131.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer183_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 57L41.4 44.65",
    strokeOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer182_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 56.75L27.4 44.9",
    strokeOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer181_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 52.85L34.3 48.8",
    strokeOpacity: 0.77
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.77
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.22;.224;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f90o48",
    transform: "matrix(.601 -.799 .799 .601 -9.45 98.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer180_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 57.7L41.4 43.95",
    strokeOpacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer179_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 55.95L27.4 45.7",
    strokeOpacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer178_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 49.6L34.3 52.05",
    strokeOpacity: 0.73
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.73
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.215;.22;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f89o47",
    transform: "matrix(.923 -.385 .385 .923 12.05 58.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer177_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 58.45L41.4 43.2",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer176_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 55.15L27.4 46.5",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.7 -38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer175_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M82 88.6L82 89.25",
    strokeOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.211;.215;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f88o46",
    transform: "matrix(.997 -.08 .08 .997 33.7 41.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer174_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 59.15L41.4 42.5",
    strokeOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer173_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 54.4L27.4 47.25",
    strokeOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer172_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 49.6L34.3 52.05",
    strokeOpacity: 0.85
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.85
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.206;.211;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f82o40",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer156_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 56.75L41.4 44.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer155_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 52.75L27.4 48.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer154_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 56.3L34.3 45.35"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.179;.184;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f81o39",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer153_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 55.95L41.4 45.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer152_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 53.45L27.4 48.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer151_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 57L34.3 44.65"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.175;.179;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f80o38",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer150_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 55.15L41.4 46.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer149_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 54.2L27.4 47.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer148_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 57.7L34.3 43.95"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.17;.175;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f79o37",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer147_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 54.4L41.4 47.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer146_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 54.9L27.4 46.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer145_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 58.45L34.3 43.2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.166;.17;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f78o36",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer144_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 53.6L41.4 48.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer143_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 55.6L27.4 46.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer142_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 59.15L34.3 42.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.161;.166;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f77o35",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer141_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 52.85L41.4 48.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer140_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 56.3L27.4 45.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer139_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 41.8L34.3 59.85"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.157;.161;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f76o34",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer138_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 49.6L41.4 52.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer137_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 57L27.4 44.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer136_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 41.8L34.3 59.85"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.152;.157;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f75o33",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.6 -38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer135_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M82 88.6L82 89.25"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer134_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 57.7L27.4 43.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer133_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 59.05L34.3 42.6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.148;.152;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f74o32",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer132_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 49.6L41.4 52.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer131_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 58.45L27.4 43.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer130_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 58.3L34.3 43.35"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.143;.148;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f73o31",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer129_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 52.75L41.4 48.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer128_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 59.15L27.4 42.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer127_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 57.5L34.3 44.15"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.139;.143;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f72o30",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer126_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 53.45L41.4 48.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer125_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 41.8L27.4 59.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer124_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 56.75L34.3 44.9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.135;.139;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f71o29",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer123_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 54.2L41.4 47.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer122_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 41.8L27.4 59.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer121_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 55.95L34.3 45.7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.13;.135;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f70o28",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer120_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 54.9L41.4 46.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer119_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 59.05L27.4 42.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer118_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 55.15L34.3 46.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.126;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f69o27",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer117_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 55.6L41.4 46.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer116_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 58.3L27.4 43.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer115_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 54.4L34.3 47.25"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.121;.126;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f68o26",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer114_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 56.3L41.4 45.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer113_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 57.5L27.4 44.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer112_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 53.6L34.3 48.05"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.117;.121;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f67o25",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer111_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 57L41.4 44.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer110_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 56.75L27.4 44.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer109_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 52.85L34.3 48.8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.112;.117;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f66o24",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer108_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 57.7L41.4 43.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer107_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 55.95L27.4 45.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer106_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 49.6L34.3 52.05"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.108;.112;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f65o23",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer105_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 58.45L41.4 43.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer104_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 55.15L27.4 46.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.7 -38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer103_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M82 88.6L82 89.25"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.103;.108;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f64o22",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer102_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 59.15L41.4 42.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer101_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 54.4L27.4 47.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer100_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 49.6L34.3 52.05"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.099;.103;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f63o21",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer99_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 41.8L41.4 59.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer98_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 53.6L27.4 48.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer97_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 52.75L34.3 48.9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.094;.099;.202;.206;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f62o20",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer96_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 41.8L41.4 59.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer95_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 52.85L27.4 48.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer94_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 53.45L34.3 48.2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.09;.094;.197;.202;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f61o19",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer93_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 59.05L41.4 42.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer92_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 49.6L27.4 52.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer91_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 54.2L34.3 47.45"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.085;.09;.193;.197;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f60o18",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer90_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 58.3L41.4 43.35"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54.6 -38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer89_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M82 88.6L82 89.25"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer88_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 54.9L34.3 46.75"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.081;.085;.188;.193;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f59o17",
    transform: "translate(40.6 38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer87_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 57.5L41.4 44.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer86_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 49.6L27.4 52.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer85_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 55.6L34.3 46.05"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.076;.081;.184;.188;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f58o16",
    transform: "matrix(1 .013 -.013 1 41.55 37.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer84_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 56.75L41.4 44.9",
    strokeOpacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer83_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 52.75L27.4 48.9",
    strokeOpacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer82_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 56.3L34.3 45.35",
    strokeOpacity: 0.98
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.98
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.072;.076;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f57o15",
    transform: "matrix(1 .026 -.026 1 42.55 36.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer81_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 55.95L41.4 45.7",
    strokeOpacity: 0.97
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer80_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 53.45L27.4 48.2",
    strokeOpacity: 0.97
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer79_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 57L34.3 44.65",
    strokeOpacity: 0.97
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.97
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.067;.072;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f56o14",
    transform: "matrix(1 .039 -.039 1 43.5 36.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer78_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 55.15L41.4 46.5",
    strokeOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer77_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 54.2L27.4 47.45",
    strokeOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer76_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 57.7L34.3 43.95",
    strokeOpacity: 0.96
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.96
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.063;.067;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f55o13",
    transform: "matrix(1 .052 -.052 1 44.4 35.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer75_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 54.4L41.4 47.25",
    strokeOpacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer74_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 54.9L27.4 46.75",
    strokeOpacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer73_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 58.45L34.3 43.2",
    strokeOpacity: 0.94
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.94
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.058;.063;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f54o12",
    transform: "matrix(.995 .1 -.1 .995 48.15 34.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer72_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 53.6L41.4 48.05",
    strokeOpacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer71_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 55.6L27.4 46.05",
    strokeOpacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer70_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 59.15L34.3 42.5",
    strokeOpacity: 0.93
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.93
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.054;.058;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f53o11",
    transform: "matrix(.989 .147 -.147 .989 51.95 32.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer69_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 52.85L41.4 48.8",
    strokeOpacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer68_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 56.3L27.4 45.35",
    strokeOpacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer67_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 41.8L34.3 59.85",
    strokeOpacity: 0.91
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.91
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.049;.054;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f52o10",
    transform: "matrix(.981 .195 -.195 .981 55.7 31.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer66_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 49.6L41.4 52.05",
    strokeOpacity: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer65_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 57L27.4 44.65",
    strokeOpacity: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer64_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 41.8L34.3 59.85",
    strokeOpacity: 0.89
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.89
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.045;.049;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f51o9",
    transform: "matrix(.957 .289 -.289 .957 63.6 30.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.6 -38.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer63_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M82 88.6L82 89.25",
    strokeOpacity: 0.88
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer62_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 57.7L27.4 43.95",
    strokeOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer61_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 59.05L34.3 42.6",
    strokeOpacity: 0.88
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.88
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.04;.045;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f50o8",
    transform: "matrix(.924 .381 -.381 .924 71.8 29.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer60_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 49.6L41.4 52.05",
    strokeOpacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer59_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 58.45L27.4 43.2",
    strokeOpacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer58_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 58.3L34.3 43.35",
    strokeOpacity: 0.86
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.86
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.036;.04;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f49o7",
    transform: "matrix(.831 .555 -.555 .831 88.3 30.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer57_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 52.75L41.4 48.9",
    strokeOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer56_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 59.15L27.4 42.5",
    strokeOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer55_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 57.5L34.3 44.15",
    strokeOpacity: 0.84
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.031;.036;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f48o6",
    transform: "matrix(.706 .708 -.708 .706 104.15 35.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer54_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 53.45L41.4 48.2",
    strokeOpacity: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer53_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 41.8L27.4 59.85",
    strokeOpacity: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer52_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 56.75L34.3 44.9",
    strokeOpacity: 0.83
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.83
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.027;.031;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f47o5",
    transform: "matrix(.495 .869 -.869 .495 123.9 46.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer51_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 54.2L41.4 47.45",
    strokeOpacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer50_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 41.8L27.4 59.85",
    strokeOpacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer49_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 55.95L34.3 45.7",
    strokeOpacity: 0.82
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.82
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.022;.027;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f46o4",
    transform: "matrix(0 1 -1 0 151 80.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer48_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 54.9L41.4 46.75",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer47_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 59.05L27.4 42.6",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer46_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 55.15L34.3 46.5",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.018;.022;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f45o3",
    transform: "matrix(-.609 .793 -.793 -.609 156.05 134.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer45_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 55.6L41.4 46.05",
    strokeOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer44_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 58.3L27.4 43.35",
    strokeOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer43_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 54.4L34.3 47.25",
    strokeOpacity: 0.65
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.65
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.013;.018;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f44o2",
    transform: "matrix(-.966 .259 -.259 -.966 127.55 181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer42_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 56.3L41.4 45.35",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer41_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 57.5L27.4 44.15",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer40_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 53.6L34.3 48.05",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.009;.013;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f43o1",
    transform: "matrix(-.997 .07 -.07 -.997 114.35 195.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer39_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 57L41.4 44.65",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer38_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 56.75L27.4 44.9",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer37_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 52.85L34.3 48.8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0.25
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.004;.009;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-5f42",
    transform: "matrix(-1 0 0 -1 109 194.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer36_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.4 57.7L41.4 43.95",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer35_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.4 55.95L27.4 45.7",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer34_0_1_STROKES",
    stroke: "#EA2427",
    strokeWidth: 3.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.3 49.6L34.3 52.05",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -124.35 -66.2)",
    id: "Layer210_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M400.7 165.7Q383.2 164.8 366.95 170.95 341.6 180.6 326.5 202.3 311.4 224 311.2 251.05 311.1 266.4 311.2 297.1 311.3 310.85 320.25 320.85 321 321.7 322.9 323.55 324.6 325.2 325.45 326.25 330.85 333.1 339.35 334.5 341.15 334.85 344.6 335.95 345.75 336.25 347.05 336.25 355.2 335.85 361.05 330 366.95 324.1 367.05 316 367.45 294.1 367.05 272.1 366.95 265.8 363.65 261 360.45 256.45 354.55 253.65 348 250.5 342.05 252.7 340.45 253.3 337.6 254.1 334.35 255.05 333.1 255.45 331.5 256.05 330.15 257.25 330.05 257.35 325.6 261.65 322.4 212.95 359.9 190.35 378.6 179.1 397.7 179.35 416.8 179.65 435.2 191.4 470.85 214.2 467.75 261.5L466.75 260.7Q462.7 255.25 454.85 253.8 453.75 253.6 451.95 253 449.8 252.35 449.05 252.15 447.65 251.8 446.6 251.8 438.7 251.9 432.6 257.75 426.45 263.65 426.3 271.5 426.1 284.35 426.3 316.5 426.3 321.7 429.9 326.95 433.75 332.6 439.65 334.75 445.45 336.85 452.05 335.05 457.35 333.5 457.85 333.4 462.15 332.5 465 329.2 466.95 326.95 471.3 322.8 482.15 311.95 482.15 296.4L482.15 251.65Q482.15 236.7 477.3 222.65 471.65 206.25 459.8 193.4 448.4 181 432.95 173.8 417.5 166.55 400.7 165.7Z",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.004;1",
    values: "inline;none;none"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-8",
    transform: "matrix(.122 0 0 1.114 73 60.55)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.439;.444;.462;.48;.507;.58299;.601;.619;.632;.641;.65;1",
    values: "76.905,83.897;76.905,83.897;76.968,83.897;76.975,83.897;76.95,83.842;76.997,83.953;76.841,83.786;76.841,83.786;77.01,84.002;76.939,83.897;76.906,83.902;76.857,83.902;76.8,83.786;76.8,83.786"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.439;.444;.462;.48;.507;.58299;.601;.619;.632;.641;.65;.655;1",
    values: ".122,1.114;.122,1.114;.377,1.114;.584,1.114;.967,1.114;1.103,1.114;1.114,1.114;1.114,1.114;1.043,1.114;.706,1.114;.347,1.114;.138,1.114;.025,1.114;.01,1.114;.01,1.114"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.439;.444;.462;.48;.507;.58299;.601;.619;.632;.641;.65;.655;1",
    values: "-32.3,-21;-32.3,-21;-31.75,-21;-31.65,-21;-31.55,-20.95;-31.6,-21.05;-31.45,-20.9;-31.45,-20.9;-31.55,-21.05;-31.7,-21;-32,-21.05;-32.55,-21.05;-33.35,-20.9;-31.45,-20.9;-31.45,-20.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.439;.63199;.641;.65;.655;1",
    values: ".54;.54;1;1;.81;.55;.22;.22"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.309 0 0 .309 -231.9 -59.65)",
    id: "Layer33_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M750.85 198.6Q749.85 199.85 749.85 201.4L749.85 313.7Q749.85 315.9 751.65 317.3 753.4 318.65 755.55 318.05 792.5 308 825.65 316.55 842.2 320.8 851.35 327.1L857.65 323.5Q866 319.4 876.1 316.75 908.6 308.4 947.15 318.2 949.35 318.75 951.05 317.35 952.8 316 952.8 313.8L952.8 201.6Q952.8 199.95 951.75 198.7 950.75 197.45 949.15 197.1 909.8 189.55 876.65 200 866.25 203.25 857.8 207.95L851.35 211.95Q841.95 204.55 825 198.95 791.05 187.8 753.3 197 751.8 197.4 750.85 198.6Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.659;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-7",
    transform: "matrix(.056 0 0 1.123 75.35 51.45)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.439;.444;.448;.462;.471;.475;.48;.484;.489;.507;.58299;.601;.619;.632;.641;.65;.655;1",
    values: "76.902,77.903;76.902,77.903;77.001,77.903;77.054,77.903;77.12,77.903;77.087,77.903;77.206,77.958;77.321,78.014;77.244,77.903;77.191,78.008;77.163,77.958;77.021,77.903;77.021,77.903;77.076,78.008;76.957,77.958;76.955,78.014;76.903,78.014;76.801,77.903;76.8,77.903;76.8,77.903"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.439;.444;.448;.462;.471;.475;.48;.484;.489;.507;.58299;.601;.619;.632;.641;.65;.655;1",
    values: ".056,1.123;.056,1.123;.173,1.123;.268,1.123;.357,1.123;.777,1.123;.945,1.123;1.017,1.123;1.055,1.123;1.097,1.123;1.089,1.123;1.123,1.123;1.123,1.123;.975,1.123;.482,1.123;.113,1.123;.052,1.123;.026,1.123;.01,1.123;.01,1.123"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.439;.444;.448;.462;.471;.475;.48;.484;.489;.507;.58299;.601;.619;.632;.641;.65;.655;1",
    values: "-27.65,-23.6;-27.65,-23.6;-27.5,-23.6;-27.3,-23.6;-27.4,-23.6;-27.15,-23.6;-27.1,-23.65;-27.2,-23.7;-27.3,-23.6;-27.2,-23.65;-27.2,-23.65;-27,-23.6;-27,-23.6;-27.1,-23.65;-27.2,-23.65;-27.8,-23.7;-29.05,-23.7;-29.25,-23.6;-36.45,-23.6;-36.45,-23.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.439;.63199;.641;.65;.655;1",
    values: ".54;.54;1;1;.81;.55;.22;.22"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.1 -53)",
    id: "Layer32_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M84.4 95.35Q92.9 91.4 102.3 94.5L103.75 94.95 103.75 54.45 102.9 54.25Q92.45 51.85 83.3 55.65 80.45 56.8 78.05 58.5L78 58.55 76.95 59.35Q74.35 57.1 70.25 55.35 60.9 51.3 50.85 54.3L50.1 54.5 50.1 94.95 51.5 94.5Q61.15 91.4 69.5 95.4L69.5 95.35Q71.95 96.55 74.3 98.35L74.35 98.35Q75.3 99.1 76 99.5 76.05 99.6 76.15 99.7 76.25 99.85 76.45 99.9 76.65 100 76.9 100 77.15 100 77.35 99.95 77.55 99.9 77.7 99.7 77.75 99.6 77.85 99.45 78.55 99.05 79.45 98.35L79.5 98.35Q81.85 96.55 84.4 95.35M84.15 57.65Q92.3 54.25 101.55 56.2L101.55 92.05Q92.1 89.4 83.5 93.4 80.75 94.65 78.15 96.6L78.15 96.65Q78.05 96.7 78 96.75L78 61.3 79.3 60.25Q81.5 58.7 84.15 57.65M69.4 57.35Q73.4 59.05 75.8 61.25L75.8 96.8Q75.75 96.7 75.65 96.65 73.1 94.7 70.45 93.4 61.95 89.4 52.25 92.05L52.25 56.15Q61.1 53.75 69.4 57.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M75.8 61.25Q73.4 59.05 69.4 57.35 61.1 53.75 52.25 56.15L52.25 92.05Q61.95 89.4 70.45 93.4 73.1 94.7 75.65 96.65 75.75 96.7 75.8 96.8L75.8 61.25M101.55 56.2Q92.3 54.25 84.15 57.65 81.5 58.7 79.3 60.25L78 61.3 78 96.75Q78.05 96.7 78.15 96.65L78.15 96.6Q80.75 94.65 83.5 93.4 92.1 89.4 101.55 92.05L101.55 56.2Z"
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.435;.659;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lined223",
    transform: "translate(-52.4 96.45)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "line_1.172"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.3 -94.8)",
    id: "Layer31_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M45.2 101.85Q52.337 104.319 59.45 102L59.5 101.95Q65.915 99.842 72.9 101.6 80.594 103.541 86.85 101.8 92.501 100.247 97.75 101.5L97.75 101.5Q102.622 102.656 107.6 102.55L107.65 102.55Q108.575 102.5 109.45 102.45 109.983 102.415 110.3 102 110.674 101.639 110.65 101.1 110.616 100.615 110.2 100.25 109.839 99.925 109.3 99.95 108.449 99.998 107.55 100.05L107.5 100.05Q102.865 100.137 98.35 99.05L98.3 99.05Q92.485 97.655 86.2 99.4 80.505 100.958 73.5 99.2 65.784 97.257 58.7 99.6L58.7 99.6Q52.362 101.680 46 99.5 41.549 98.035 37.1 98.45 32.633 98.823 30.4 99.8 29.934 100.000 29.75 100.45 29.551 100.963 29.75 101.45 29.950 101.916 30.4 102.1 30.912 102.298 31.4 102.1 33.367 101.276 37.3 100.95L37.3 100.95Q41.262 100.568 45.2 101.85Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.771;.821;1",
    values: "none;inline;none;none"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "mask",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.771;1",
    values: "none;url(#mask_6);url(#mask_6)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.182"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer30_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M146.7 3.2Q146.2 1.8 145.2 .05L62.55 4.35 64.25 16.1 145.85 9.7Q146.7 7.75 146.9 6.55 148.1 5.55 147.85 4.8 147.55 3.95 146.7 3.2Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.816;.821;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.181"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer29_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M143.55 3.5Q143.05 2.15 142 .4L59.4 5.55 61.2 17.3 142.75 10.05Q143.6 8.05 143.8 6.85 145 5.85 144.7 5.1 144.4 4.25 143.55 3.5Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.812;.816;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.180"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer28_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M140.35 3.75Q139.9 2.4 138.9 .6L56.15 2.45 57.5 14.25 139.3 10.3Q140.25 8.3 140.5 7.15 141.7 6.2 141.45 5.4 141.2 4.55 140.35 3.75Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.807;.812;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.179"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer27_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M133.9 4.55Q133.4 3.25 132.4 1.45L49.75 5.55 51.4 17.25 133 11.15Q133.9 9.1 134.15 7.95 135.3 6.95 135.05 6.2 134.75 5.35 133.9 4.55Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.803;.807;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.178"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer26_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M125.9 3.3Q125.4 2 124.35 .25L41.85 6.55 43.8 18.2 125.2 9.95Q126.05 7.85 126.25 6.7 127.4 5.65 127.1 4.9 126.8 4.05 125.9 3.3Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.798;.803;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.177"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer25_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M117.4 9.5Q118.15 7.4 118.3 6.2 119.45 5.15 119.15 4.45 118.75 3.6 117.85 2.9 117.3 1.6 116.2 -.1L34 9.2 36.4 20.75 117.4 9.5Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.794;.798;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.176"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer24_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M112.25 4.55Q111.9 3.2 110.95 1.35L28.2 1.45 29.3 13.25 111.1 11.05Q112.05 9.1 112.35 7.95 113.55 7 113.35 6.2 113.1 5.35 112.25 4.55Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.789;.794;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.175"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer23_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M104.75 5.3Q104.35 3.95 103.35 2.1L20.7 3.9 22.05 15.7 103.75 11.8Q104.65 9.85 104.9 8.65 106.1 7.7 105.85 6.9 105.6 6.05 104.75 5.3Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.785;.789;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.174"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer22_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M93.9 9.6Q94.75 7.65 95 6.45 96.15 5.45 95.9 4.65 95.65 3.85 94.75 3.1 94.35 1.75 93.3 -.05L10.7 3.45 12.3 15.2 93.9 9.6Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.78;.785;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.173"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer21_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M88.45 3.45Q88 2.1 86.9 .35L4.35 5.55 6.2 17.25 87.7 10Q88.5 8 88.75 6.8 89.9 5.8 89.6 5 89.35 4.2 88.45 3.45Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.776;.78;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_0.172"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer20_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M84.1 3.8Q83.6 2.45 82.5 .7L0 7.6 2.1 19.3 83.5 10.35Q84.25 8.35 84.45 7.15 85.6 6.1 85.3 5.3 85 4.5 84.1 3.8Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.771;.776;1",
    values: "none;inline;none;none"
  }))))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_)",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.257 .966 -.966 .257 117.65 115.9)",
    id: "Symbol-6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M38.55 22.3L38.85 22 31.1 12.15 30.85 12.45 30.75 12.5 4.85 33Q4.05 33.6 3.65 34.6L.25 43.55 .25 43.55Q-.048 44.304 .05 44.7 .2 45.1 .8 45.5L1.4 45.6 1.65 45.5 10.85 43.65Q11.8 43.45 12.55 42.85 34.35 25.6 38.55 22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M54.6 8.35Q54.8 7.05 53.85 5.9L50.3 1.35Q49.35 .2 48.05 .05 46.7 -.15 45.6 .75L33.8 10.1 41.5 19.95 45.25 17.05 46.4 18.5Q46.95 19.2 46.95 19.65 46.85 20.05 46.15 20.65L30.65 32.8Q30.610 32.836 30.55 32.85 29.955 33.506 30.05 34.45 30.15 35.4 30.95 35.95 32.2 36.85 33.6 35.75L48.85 23.75Q50.8 22.25 51.05 20.1 51.3 18 49.8 16.1L48.5 14.5 48.6 14.35 53.3 10.6Q54.45 9.75 54.6 8.35Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.619;.623;.628;.632;.637;.641;.65;.659;.664;.673;.677;.682;.695;.713;.726;.744;.76199;.767;.771;.776;.78;.785;.794;.803;.807;.816;1",
    values: "71.643,127.363;71.643,127.363;71.644,123.783;74.517,123.364;75.032,121.497;75.305,120.313;77.578,114.616;78.714,101.124;75.412,93.109;74.223,91.73;68.729,87.846;69.028,87.89;67.963,86.792;59.852,89.547;44.455,98.311;35.839,102.459;31.269,104.508;31.269,104.508;31.491,104.206;34.077,104.521;39.136,104.58;45.468,104.718;54.79,104.639;69.378,104.648;83.884,104.6;91.077,104.593;97.723,104.608;97.723,104.608"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.619;.623;.628;.632;.637;.641;.65;.659;.664;.673;.677;.682;.695;.713;.726;.744;.76199;.767;.771;.776;.78;.785;.794;.803;.807;.816;1",
    values: "75.125,0,0;75.125,0,0;66.403,0,0;46.677,0,0;34.561,0,0;22.178,0,0;13.748,0,0;.817,0,0;-9.312,0,0;-14.378,0,0;-16.471,0,0;-17.1,0,0;-17.1,0,0;-19.353,0,0;-24.612,0,0;-28.555,0,0;-32.778,0,0;-32.778,0,0;-34.012,0,0;-35.246,0,0;-36.483,0,0;-34.859,0,0;-33.869,0,0;-35.803,0,0;-32.135,0,0;-32.524,0,0;-33.725,0,0;-33.725,0,0"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.623;.628;.632;.637;.641;.65;.659;.713;.726;1",
    values: "1,.999;1,.999;.998,.998;.998,.998;1,.999;1,.999;1,1;1,.999;1,.999;.998,.998;.998,.998"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.619;.623;.628;.632;.637;.641;.65;.659;.664;.673;.677;.682;.695;.713;.726;.744;.76199;.767;.771;.776;.78;.785;.794;.803;.807;.816;1",
    values: ".7,-47.4;.7,-47.4;.8,-47.4;.85,-47.4;.95,-47.55;.9,-47.6;.9,-47.55;1,-47.55;1,-47.5;1,-47.6;.95,-47.7;.95,-47.6;.95,-47.55;1,-47.7;.95,-47.75;1,-47.7;1.05,-47.6;1.05,-47.6;1,-47.7;.95,-47.8;1,-47.7;1.05,-47.75;1,-47.8;.9,-47.85;.9,-47.8;.95,-47.7;.95,-47.8;.95,-47.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.619;.623;.628;.632;.637;.641;.65;1",
    values: ".07;.07;.52;.75;.88;.91;.94;1;1"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.619;.821;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11 0 0 1.11 -8.2 -8.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M140.5 76.05Q140.5 48.75 121.2 29.4 101.85 10.1 74.55 10.1 47.25 10.1 27.9 29.4 8.55 48.75 8.55 76.05 8.55 103.35 27.9 122.7 47.25 142.05 74.55 142.05 101.85 142.05 121.2 122.7 140.5 103.35 140.5 76.05Z",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;1",
    values: "inline;none;none"
  })))), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line033t186o187d223",
    transform: "translate(-52.4 96.45)",
    display: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.85199;.892;1",
    values: "1;1;0;0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M151.05 6.75L151.1 6.75Q153.05 7.2 155.05 7.45 156.05 6.6 155.85 5.85 155.7 5.4 155.45 5 153.5 4.75 151.65 4.3 145.8 2.85 139.55 4.6 133.8 6.15 126.8 4.4 119.1 2.45 112 4.85L112.05 4.8Q105.65 6.9 99.3 4.75 94.85 3.25 90.4 3.65 85.95 4 83.7 5 83.25 5.2 83.05 5.7 82.85 6.15 83.05 6.65 83.25 7.1 83.75 7.3 84.2 7.5 84.7 7.3 86.65 6.5 90.6 6.15L90.65 6.15Q94.55 5.75 98.5 7.1 105.65 9.5 112.8 7.2 119.2 5.05 126.2 6.8 133.9 8.75 140.2 7 145.8 5.45 151.05 6.75Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.839;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.839;.897;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line02t183o183d223",
    transform: "translate(-52.4 96.45)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_5)",
    display: "none",
    id: "line02_1.172"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.3 -94.8)",
    id: "Layer17_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M45.2 101.85Q52.337 104.319 59.45 102L59.5 101.95Q65.915 99.842 72.9 101.6 80.594 103.541 86.85 101.8 92.501 100.247 97.75 101.5L97.75 101.5Q102.622 102.656 107.6 102.55L107.65 102.55Q108.575 102.5 109.45 102.45 109.983 102.415 110.3 102 110.674 101.639 110.65 101.1 110.616 100.615 110.2 100.25 109.839 99.925 109.3 99.95 108.449 99.998 107.55 100.05L107.5 100.05Q102.865 100.137 98.35 99.05L98.3 99.05Q92.485 97.655 86.2 99.4 80.505 100.958 73.5 99.2 65.784 97.257 58.7 99.6L58.7 99.6Q52.362 101.680 46 99.5 41.549 98.035 37.1 98.45 32.633 98.823 30.4 99.8 29.934 100.000 29.75 100.45 29.551 100.963 29.75 101.45 29.950 101.916 30.4 102.1 30.912 102.298 31.4 102.1 33.367 101.276 37.3 100.95L37.3 100.95Q41.262 100.568 45.2 101.85Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line02_0.186"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer16_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M154.75 4.25Q154.35 2.85 153.35 1.05L70.65 2 71.85 13.8 153.65 10.75Q154.6 8.8 154.85 7.6 156.05 6.65 155.85 5.85 155.6 5 154.75 4.25Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.834;.839;.852;.857;.87;.874;.888;.892;.906;.91;.924;.928;.942;.946;.96;.964;.978;.982;.996;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line02_0.185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer15_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M154.2 4.25Q153.8 2.85 152.8 1.1L70.1 2.85 71.45 14.65 153.2 10.75Q154.1 8.8 154.35 7.6 155.55 6.65 155.35 5.85 155.05 5 154.2 4.25Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.83;.834;.848;.852;.865;.87;.883;.888;.901;.906;.919;.924;.937;.942;.955;.96;.973;.978;.991;.996;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line02_0.184"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer14_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M153.35 4.05Q152.9 2.65 151.9 .9L69.2 3.5 70.7 15.25 152.4 10.55Q153.25 8.6 153.5 7.4 154.7 6.4 154.5 5.65 154.2 4.8 153.35 4.05Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.825;.83;.843;.848;.861;.865;.879;.883;.897;.901;.915;.919;.933;.937;.951;.955;.969;.973;.987;.991;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line02_0.183"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer13_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M149.8 3.4Q149.35 2 148.35 .25L65.65 3.7 67.25 15.45 148.9 9.9Q149.75 7.95 150 6.75 151.2 5.75 150.95 5 150.65 4.15 149.8 3.4Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;.825;.839;.843;.857;.861;.874;.879;.892;.897;.91;.915;.928;.933;.946;.951;.964;.969;.982;.987;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
  }))))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;.839;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-11f223o222",
    transform: "translate(5.25 9.8)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_4)",
    id: "Symbol 11_1.223"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.847 -.531 .531 -.847 49.7 171.6)",
    id: "Layer12_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M38.55 22.3L38.85 22 31.1 12.15 30.85 12.45 30.8 12.55 4.85 33Q4.05 33.6 3.65 34.6L.25 43.55 .25 43.6Q-.05 44.3 .05 44.7 .2 45.1 .8 45.5L1.4 45.6 1.65 45.5 10.85 43.65Q11.8 43.45 12.55 42.85 34.35 25.6 38.55 22.3Z",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M54.6 8.35Q54.8 7.05 53.85 5.9L50.3 1.35Q49.35 .2 48.05 .05 46.7 -.15 45.6 .75L33.8 10.1 41.5 19.95 45.25 17.05 46.4 18.5Q46.95 19.2 46.95 19.65 46.85 20.05 46.15 20.65L30.65 32.8Q30.6 32.85 30.6 32.9 29.95 33.5 30.05 34.45 30.15 35.4 30.95 35.95 32.2 36.85 33.6 35.75L48.85 23.75Q50.8 22.25 51.05 20.1 51.3 18 49.8 16.1L48.5 14.5 48.6 14.35 53.3 10.6Q54.45 9.75 54.6 8.35Z",
    fillOpacity: 0.33
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Symbol 11_0.184"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11 0 0 1.11 -8 -7.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer3_0_FILL4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M141.75 63.3Q147.8 33.3 122.1 16.85 96.35 .35 69.05 .35 41.75 .35 22.4 19.65 3.05 39 3.05 66.3 3.05 93.6 22.4 112.95 41.75 132.3 69.05 132.3 96.35 132.3 116.05 112.8 135.7 93.3 141.75 63.3Z",
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.996;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-11f222o221",
    transform: "translate(5.25 9.8)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_3)",
    id: "Symbol 11_1.222"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.79 -.613 .613 -.79 47.45 161.5)",
    id: "Layer11_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M38.55 22.3L38.85 22 31.1 12.15 30.85 12.45 30.8 12.55 4.85 33Q4.05 33.6 3.65 34.6L.25 43.55 .25 43.6Q-.05 44.3 .05 44.7 .2 45.1 .8 45.5L1.4 45.6 1.65 45.5 10.85 43.65Q11.8 43.45 12.55 42.85 34.35 25.6 38.55 22.3Z",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M54.6 8.35Q54.8 7.05 53.85 5.9L50.3 1.35Q49.35 .2 48.05 .05 46.7 -.15 45.6 .75L33.8 10.1 41.5 19.95 45.25 17.05 46.4 18.5Q46.95 19.2 46.95 19.65 46.85 20.05 46.15 20.65L30.65 32.8Q30.6 32.85 30.6 32.9 29.95 33.5 30.05 34.45 30.15 35.4 30.95 35.95 32.2 36.85 33.6 35.75L48.85 23.75Q50.8 22.25 51.05 20.1 51.3 18 49.8 16.1L48.5 14.5 48.6 14.35 53.3 10.6Q54.45 9.75 54.6 8.35Z",
    fillOpacity: 0.55
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Symbol 11_0.184"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11 0 0 1.11 -8 -7.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer3_0_FILL3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M141.75 63.3Q147.8 33.3 122.1 16.85 96.35 .35 69.05 .35 41.75 .35 22.4 19.65 3.05 39 3.05 66.3 3.05 93.6 22.4 112.95 41.75 132.3 69.05 132.3 96.35 132.3 116.05 112.8 135.7 93.3 141.75 63.3Z",
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.991;.996;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-11f221o220",
    transform: "translate(5.25 9.8)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_2)",
    id: "Symbol 11_1.221"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.668 -.743 .743 -.668 41.3 141.5)",
    id: "Layer10_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M38.55 22.3L38.85 22 31.1 12.15 30.85 12.45 30.8 12.55 4.85 33Q4.05 33.6 3.65 34.6L.25 43.55 .25 43.6Q-.05 44.3 .05 44.7 .2 45.1 .8 45.5L1.4 45.6 1.65 45.5 10.85 43.65Q11.8 43.45 12.55 42.85 34.35 25.6 38.55 22.3Z",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M54.6 8.35Q54.8 7.05 53.85 5.9L50.3 1.35Q49.35 .2 48.05 .05 46.7 -.15 45.6 .75L33.8 10.1 41.5 19.95 45.25 17.05 46.4 18.5Q46.95 19.2 46.95 19.65 46.85 20.05 46.15 20.65L30.65 32.8Q30.6 32.85 30.6 32.9 29.95 33.5 30.05 34.45 30.15 35.4 30.95 35.95 32.2 36.85 33.6 35.75L48.85 23.75Q50.8 22.25 51.05 20.1 51.3 18 49.8 16.1L48.5 14.5 48.6 14.35 53.3 10.6Q54.45 9.75 54.6 8.35Z",
    fillOpacity: 0.88
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Symbol 11_0.184"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11 0 0 1.11 -8 -7.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer3_0_FILL2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M141.75 63.3Q147.8 33.3 122.1 16.85 96.35 .35 69.05 .35 41.75 .35 22.4 19.65 3.05 39 3.05 66.3 3.05 93.6 22.4 112.95 41.75 132.3 69.05 132.3 96.35 132.3 116.05 112.8 135.7 93.3 141.75 63.3Z",
    fillOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.987;.991;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-11t184o183d223",
    transform: "translate(5.25 9.8)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.98699;.987;1",
    values: "1;1;.88;.88",
    calcMode: "discrete"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 11_1.220"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.1 -19.6)",
    id: "Layer8_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFF",
    stroke: "none",
    d: "M60.8 91.8Q60.75 91.8 60.7 91.85L52.65 87.1 52.65 90.95Q59.960 95.196 76.75 104.9 77.235 105.233 77.6 105.65 77.818 105.960 78.1 106.35 79.072 105.304 80.85 104 79.590 102.421 78.4 101.7L60.8 91.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M48.05 88.3L47.6 88.1 41.3 98.9 41.7 99.05 41.75 99.05 70.3 115.7Q71.15 116.25 72.25 116.25L81.85 116.1Q82.6 116.15 83 115.9 83.3 115.6 83.4 114.9L83.3 114.3 83.1 114.1 78.05 106.2Q77.5 105.4 76.65 104.95 52.6 91 48.05 88.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M36.95 81.85L31.75 78.8Q30.5 78.1 29.15 78.45 27.9 78.7 27.2 80.05L24.25 85Q23.55 86.35 23.85 87.6 24.15 88.9 25.4 89.65L38.4 97.15 44.75 86.4 40.7 83.95 41.6 82.4Q42.05 81.6 42.5 81.45 42.9 81.35 43.7 81.8L60.7 91.8Q60.75 91.8 60.8 91.8 61.6 92.2 62.45 91.75 63.3 91.3 63.5 90.35 63.9 88.85 62.35 87.95L45.6 78.15Q43.5 76.9 41.4 77.45 39.35 78 38.15 80.1L37.15 81.9 36.95 81.85Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.982;.987;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 11_1.219.0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.55 -9.8)",
    id: "Layer6_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M61.65 72.8L61.35 72.5 51.85 80.7 52.2 80.95 52.3 81 73.85 106Q74.45 106.75 75.5 107.1L84.6 110.1 84.65 110.1Q85.35 110.4 85.75 110.25 86.15 110.1 86.5 109.5L86.6 108.9 86.5 108.65 84.2 99.5Q84 98.55 83.35 97.85 65.15 76.85 61.65 72.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M39 64.3Q38.9 65.65 39.85 66.7L49.7 78.1 59.15 69.95 56.15 66.35 57.55 65.15Q58.2 64.55 58.6 64.55 59 64.6 59.65 65.3L72.5 80.25Q72.55 80.3 72.6 80.3 73.2 80.9 74.15 80.75 75.1 80.65 75.65 79.8 76.45 78.5 75.3 77.15L62.65 62.45Q61.05 60.55 58.9 60.4 56.85 60.25 55 61.85L53.45 63.2 53.3 63.1 49.35 58.6Q48.45 57.45 47.05 57.4 45.7 57.25 44.6 58.25L40.2 62Q39.1 63 39 64.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.55 -9.8)",
    id: "Layer7_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFF",
    stroke: "none",
    d: "M61.35 72.6L61.65 72.85Q65.15 76.85 83.25 97.95 83.9 98.7 84.05 99.65 84.718 101.341 85 102.65 86.407 101.944 88.4 102L88 100.1Q87.1 96.9 85.85 95.5L72.55 80.3Q72.5 80.35 72.45 80.3L59.7 65.3Q59.1 64.6 58.7 64.5 58.25 64.5 57.6 65.1L56.2 66.35 59.2 69.95 55.4 73.2 55.4 77.6 61.35 72.6Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.978;.982;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 11_1.218"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.1 -19.6)",
    id: "Layer4_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFF",
    stroke: "none",
    d: "M91.9 92.9Q92.3 93.85 92.2 94.8L91.7 102.8Q92.977 103.187 94.3 103.75 95.071 103.854 95.1 103L95.1 91.25 86.9 72.9Q86.85 72.9 86.8 72.85L79 54.8Q78.65 53.95 78.3 53.7 77.85 53.6 77.05 53.95L75.35 54.75 77.2 59.05 65.7 64 67.15 67.1 78.45 62.25 78.7 62.55Q80.85 67.45 91.9 92.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M90.5 70.8L82.8 53Q81.85 50.75 79.85 49.95 77.85 49.15 75.65 50.1L73.75 50.95 73.6 50.85 71.2 45.35Q70.65 44 69.35 43.55 68.15 43 66.8 43.6L61.5 45.9Q60.15 46.5 59.7 47.7 59.15 48.95 59.7 50.3L65.75 64.1 77.25 59.15 75.4 54.75 77.1 54.05Q77.9 53.65 78.35 53.75 78.7 53.95 79.1 54.85L86.9 72.95 86.95 72.95Q87.4 73.75 88.35 73.9 89.25 74.05 90 73.45 91.2 72.45 90.5 70.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M92.3 94.8Q92.35 93.85 91.95 92.95 80.9 67.5 78.75 62.6L78.55 62.2 67.05 67.2 67.3 67.55 67.35 67.6 80.5 97.9Q80.9 98.85 81.75 99.45L89.5 105.05 89.55 105.05Q90.15 105.5 90.55 105.55 91 105.5 91.55 105.05L91.75 104.45 92.3 94.8Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.973;.978;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.828 -.559 .559 .828 69.45 54.75)",
    id: "Symbol-6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424C8F",
    stroke: "none",
    d: "M38.55 22.3L38.85 22 31.1 12.15 30.85 12.45 30.75 12.5 4.85 33Q4.05 33.6 3.65 34.6L.25 43.55 .25 43.55Q-.048 44.304 .05 44.7 .2 45.1 .8 45.5L1.4 45.6 1.65 45.5 10.85 43.65Q11.8 43.45 12.55 42.85 34.35 25.6 38.55 22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2427",
    stroke: "none",
    d: "M54.6 8.35Q54.8 7.05 53.85 5.9L50.3 1.35Q49.35 .2 48.05 .05 46.7 -.15 45.6 .75L33.8 10.1 41.5 19.95 45.25 17.05 46.4 18.5Q46.95 19.2 46.95 19.65 46.85 20.05 46.15 20.65L30.65 32.8Q30.610 32.836 30.55 32.85 29.955 33.506 30.05 34.45 30.15 35.4 30.95 35.95 32.2 36.85 33.6 35.75L48.85 23.75Q50.8 22.25 51.05 20.1 51.3 18 49.8 16.1L48.5 14.5 48.6 14.35 53.3 10.6Q54.45 9.75 54.6 8.35Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;.825;.834;.86999;.897;.919;.95099;.955;.96;.964;.969;.987;.991;1",
    values: "95.431,94.824;95.431,94.824;98.456,94.909;99.472,94.87;99.472,94.87;100.228,94.925;100.655,94.888;100.655,94.888;99.637,94.731;97.117,94.607;94.281,94.337;88.803,95.8;95.431,94.824;98.456,94.909;98.456,94.909"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;.825;.834;.86999;.897;.919;.95099;.955;.96;.964;.969;.987;.991;1",
    values: "-34.031,0,0;-34.031,0,0;-33.737,0,0;-33.443,0,0;-33.443,0,0;-25.952,0,0;-23.287,0,0;-23.287,0,0;-26.51,0,0;-33.692,0,0;-46.286,0,0;-58.51,0,0;-34.031,0,0;-33.737,0,0;-33.737,0,0"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.89699;.919;.95099;.955;1",
    values: ".998,.998;.998,.998;1,.999;1,.999;.998,.998;.998,.998"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;.825;.834;.86999;.897;.919;.95499;.96;.964;.969;.987;.991;1",
    values: ".9,-47.8;.9,-47.8;.8,-47.9;.95,-47.85;.95,-47.85;.9,-48;.9,-47.95;.9,-47.95;.85,-48.1;1,-48;1.1,-47.95;.9,-47.8;.8,-47.9;.8,-47.9"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;.973;.987;1",
    values: "none;inline;none;inline;inline"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol 11_0.184"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11 0 0 1.11 -8 -7.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer3_0_FILL1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "none",
    d: "M141.75 63.3Q147.8 33.3 122.1 16.85 96.35 .35 69.05 .35 41.75 .35 22.4 19.65 3.05 39 3.05 66.3 3.05 93.6 22.4 112.95 41.75 132.3 69.05 132.3 96.35 132.3 116.05 112.8 135.7 93.3 141.75 63.3Z",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;1",
    values: "none;inline;inline"
  }))))), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.821;.987;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle01",
    transform: "matrix(1.019 0 0 1.019 1.95 3.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle2"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;1",
    values: "71.35,71.35;71.35,71.35"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;.197;.20199;.399;.40399;.596;.60099;.794;.79799;.996;1",
    values: "0,0,0;360,0,0;360,0,0;720,0,0;720,0,0;1080,0,0;1080,0,0;1440,0,0;1440,0,0;1800,0,0;1800,0,0"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "8.92s",
    keyTimes: "0;1",
    values: "-71.35,-71.35;-71.35,-71.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    stroke: "none",
    d: "M69.3 -.75Q69 -.9 68.75 -.9 40.5 0 20.25 20.25 -1 41.45 -1 71.4 -1 101.35 20.25 122.55 41.45 143.8 71.4 143.8 101.35 143.8 122.55 122.55 142.1 103.05 143.65 76 143.65 75.7 143.55 75.5 143.4 75.25 143.2 75.1 142.95 74.95 142.65 74.95L135.45 74.95Q135.05 74.95 134.8 75.25 134.5 75.5 134.45 75.9 132.95 99.15 116.05 116.05 97.55 134.6 71.4 134.6 45.2 134.6 26.7 116.05 8.2 97.6 8.2 71.4 8.2 45.25 26.7 26.7 44.25 9.2 68.8 8.3 69.05 8.3 69.3 8.15 72.8 6 72.65 3.7 72.8 1.4 69.3 -.75Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5d025b1149a74d59a2a5658dc53d9e96.svg";
export { ForwardRef as ReactComponent };